import { render, staticRenderFns } from "./GoalSelectionModal.vue?vue&type=template&id=e56c905c&"
import script from "./GoalSelectionModal.vue?vue&type=script&lang=js&"
export * from "./GoalSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./GoalSelectionModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports